import { c as _c } from "react/compiler-runtime";
import times from 'lodash/times';
import type { JSX } from 'react';
import { cn, IconButtonAsButton, Input } from '../../../v2';
import { IconChevronLeft, IconChevronRight } from '../../icons';
import type { CalendarHook } from '../hooks/calendar';
interface Props {
  minYear?: number;
  maxYear?: number;
  calendarHook: CalendarHook;
}
const monthsInOrder = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
function Caret() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="9" height="13" viewBox="0 0 9 13"><path fillRule="evenodd" clipRule="evenodd" d="M0 8.1875H8.25L4.125 13L0 8.1875Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M0 4.8125H8.25L4.125 0L0 4.8125Z" fill="currentColor" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default function CalendarHeader(props) {
  const $ = _c(30);
  const {
    maxYear: t0,
    minYear: t1,
    calendarHook
  } = props;
  const maxYear = t0 === undefined ? 9999 : t0;
  const minYear = t1 === undefined ? 1000 : t1;
  const {
    increaseMonth,
    decreaseMonth,
    setYear,
    setMonth,
    year,
    month
  } = calendarHook;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconChevronLeft color="currentColor" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== decreaseMonth) {
    t3 = <IconButtonAsButton onClick={decreaseMonth} className="text-muted-foreground">{t2}</IconButtonAsButton>;
    $[1] = decreaseMonth;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("min-w-[100px] appearance-none bg-transparent text-base font-semibold", "dark:text-foreground rounded-xs border border-transparent focus:outline-hidden", "hover:border-border focus:border-brand-400 pt-0 pr-4 pb-0 pl-1");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = String(month);
  let t6;
  if ($[4] !== setMonth) {
    t6 = e => setMonth(parseInt(e.target.value, 10));
    $[4] = setMonth;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = times(12, _temp);
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t5 || $[8] !== t6) {
    t8 = <select className={t4} value={t5} onChange={t6}>{t7}</select>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="text-steel-300 absolute top-[50%] right-2 translate-y-[-50%]"><Caret /></div>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8) {
    t10 = <div className="relative flex-[1.5]">{t8}{t9}</div>;
    $[11] = t8;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== setYear) {
    t11 = e_0 => {
      if (e_0.target.value !== "") {
        setYear(parseInt(e_0.target.value, 10));
      }
    };
    $[13] = setYear;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== maxYear || $[16] !== minYear || $[17] !== t11 || $[18] !== year) {
    t12 = <div className="flex flex-1"><Input min={minYear} max={maxYear} value={year} onChange={t11} type="number" wrapperClassName="h-auto border-transparent hover:border-border" inputClassName="py-0 px-1 font-semibold" /></div>;
    $[15] = maxYear;
    $[16] = minYear;
    $[17] = t11;
    $[18] = year;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12) {
    t13 = <div className="flex w-full flex-1 items-center p-1">{t10}{t12}</div>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <IconChevronRight color="currentColor" />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== increaseMonth) {
    t15 = <IconButtonAsButton onClick={increaseMonth} className="text-muted-foreground">{t14}</IconButtonAsButton>;
    $[24] = increaseMonth;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15 || $[28] !== t3) {
    t16 = <div className="flex w-full items-center justify-between">{t3}{t13}{t15}</div>;
    $[26] = t13;
    $[27] = t15;
    $[28] = t3;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
}
function _temp(num) {
  return <option value={num + 1}>{monthsInOrder[num]}</option>;
}